export default "/images/brandWithoutName.png?8dcf9438f76df7fd4e6f8fac09cdc79c";